import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import CatMascot from "../components/CatMascot";

export default function Callback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const ran = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) { setError("No authorization code returned"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/discord/callback", { code });
        await login(res.data.token);
        navigate("/");
      } catch (e) {
        setError(e?.response?.data?.detail || "Discord sign-in failed");
      }
    })();
  }, [login, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0A0C10] grid-bg">
      <motion.div animate={{ scale: [1, 1.12, 1], rotate: [0, 8, -8, 0] }} transition={{ repeat: Infinity, duration: 1.3 }}>
        <CatMascot size={90} />
      </motion.div>
      {!error ? (
        <p className="mt-6 font-display text-sm uppercase tracking-[0.3em] text-purple-400">Authorizing Discord...</p>
      ) : (
        <div className="mt-6 text-center">
          <p className="text-sm text-red-400">{error}</p>
          <button onClick={() => navigate("/login")} className="mt-3 text-xs text-purple-400 underline">Back to sign in</button>
        </div>
      )}
    </div>
  );
}
